import React from 'react';
import { FiCopy, FiPlus } from 'react-icons/fi';
import { addShelf } from 'containers/Configurator/actions/furniture';
import { useDispatch } from 'react-redux';
// import styled from 'styled-components/macro';

interface Props {
  shelfLevel?: number;
}

const MobileAddShelf = ({ shelfLevel }: Props) => {
  const dispatch = useDispatch();
  function handleAddShelf() {
    if (shelfLevel) dispatch(addShelf(shelfLevel));
    else dispatch(addShelf());
  }
  return (
    <button
      onClick={handleAddShelf}
      className="bg-main rounded-full h-10 w-10 flex items-center justify-center shadow-xl"
    >
      {shelfLevel !== undefined ? (
        <FiCopy className="text-white h-6 w-6 " />
      ) : (
        <FiPlus className="text-white h-8 w-8" />
      )}
    </button>
  );
};

export default MobileAddShelf;
